import { boot } from 'quasar/wrappers'
import { plugin, defaultConfig } from '@formkit/vue'
import debounce from '../utils/debouncer' // file being imported
import {
  // createSharedElementDirective,
  SharedElementRouteGuard,
  SharedElementDirective
} from 'v-shared-element'
import { FormDataPlugin } from '@formdata/vue'
import {useStudioStore} from "stores/studio";

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot( ({ app, router }) => {
  app.directive('debounce', (el, binding) => debounce(el,binding))
  app.use(SharedElementDirective)
  app.use(plugin, defaultConfig)
  // or app.use(createSharedElementDirective())
  router.beforeEach(SharedElementRouteGuard)
  app.use(FormDataPlugin)
  let firstNavigation = true
  router.beforeEach((to, from, next) => {
    if (to.query.publishForm) {
      const studioStore = useStudioStore()
      studioStore.setPublishFormStorageKey(to.query.publishForm)
    }
    if (firstNavigation) {
      firstNavigation = false
      if (to.name === 'studio') {
        next(to.path.replace('/studio', '/build'))
        return
      }
    }
    next()
  })
})
